<template>
  <div>
    <user-list></user-list>
  </div>
</template>


<script>
import UserList from './../../components/users/list';
export default {
  data: () => ({}),
  metaInfo() {
    return {
      title: this.$i18n.t('users.title'),
    };
  },
  components: {
    UserList
  }
}
</script>